// extracted by mini-css-extract-plugin
module.exports = {"spacer":"bb_dv"};